import BaseComponent from './BaseComponent';
import Splide from '@splidejs/splide';

class Slider extends BaseComponent {
    constructor(el) {
        super(el);
        
        // Verify required Splide structure exists
        const splideTrack = el.querySelector('.splide__track');
        const splideList = el.querySelector('.splide__list');
        
        if (!splideTrack || !splideList) {
            console.warn('Slider: Missing required Splide structure (.splide__track or .splide__list)', el);
            return;
        }
        
        function getFirstNode(nodeList) {
            return [...nodeList].filter((node) => node.tagName == 'DIV')[0];
        }

        function getIndexOfElement(element) {
            return Array.from(element.parentElement.children).indexOf(element);
        }
        const splide = new Splide(el, {
              pagination: false,
              classes: {
                prev  : 'splide__arrow--prev image__slider__prev',
                next  : 'splide__arrow--next image__slider__next',
              }
        });
        const inNeosBackend = window.name == 'neos-content-main';

        // We are in the backend, so we need to refresh the instance on change
        if (inNeosBackend) {
            splide.on('mounted', function () {
                // Update if a slide is added or removed
                const observeTarget = el.querySelector('.splide__list');
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        const addedNode = getFirstNode(mutation.addedNodes);
                        const removedNode = getFirstNode(mutation.removedNodes);
                        if (addedNode || removedNode) {
                            splide.refresh();
                        }
                        if (addedNode) {
                            // Scroll to the new slide
                            splide.go(getIndexOfElement(addedNode));
                        }
                    });
                });
                observer.observe(observeTarget, { childList: true });

                // Go to the slide if it gets selceted in the node tree
                document.addEventListener('Neos.NodeSelected', (event) => {
                    const element = event.detail.element;
                    if (!element.classList.contains('splide__slide')) {
                        return;
                    }
                    splide.go(getIndexOfElement(element));
                });
            });
        }
        splide.mount();
        
        // Optional counter - only initialize if it exists
        const counter = document.querySelector('#slide-count');
        if (counter) {
            const totalSlides = splide.length;
            function updateCounter(index) {
                counter.textContent = `${index + 1} af ${totalSlides}`;
            }
            splide.on('move', (newIndex) => {
                updateCounter(newIndex);
            });
        }
    }
    
}

export default Slider;
